// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__27WSr","p":"Home_p__2nPGA"};